<template>
    <div class='cancel-project-action'>
        <button @click="showModal = true" type="button" class="button is-danger">Annullér projekt</button>

        <b-modal :active="showModal" :canCancel="['escape']">
            <div class="modal-card" style="width: auto">
                <header class="modal-card-head">
                    <p class="modal-card-title">Annullér Projekt</p>
                </header>

                <section class="modal-card-body">
                    <p>For at annullere dit projekt, beder vi dig venligst kort skrive lidt om, hvorfor du annullerer.</p>
                    <br>

                    <b-field label="Begrundelse for at annullere"
                             :type="{'is-danger': veeErrors.has('message')}"
                             :message="veeErrors.first('message')">
                        <b-input v-model="message" type="textarea" name="message"
                                 v-validate="'required'" :data-vv-as="'Begrundelse'" >
                        </b-input>
                    </b-field>

                    <p>Når du annullerer dit projekt vil det stadig fremsgå af dine projekter, men du vil ikke kunne skrive til den studerende mere.</p>
                    <br>

                    <div class="has-text-centered">
                        <b-checkbox v-model="accept">Jeg bekræfter hermed at projektet skal annulleres</b-checkbox>

                        <p v-if="!accept" class="help is-danger">Du skal bekræfte annulleringen</p>
                    </div>
                </section>

                <footer class="modal-card-foot content-pulled-right">
                    <button class="button" @click="showModal = false" type="button">{{$t('global.actions.back')}}</button>

                    <button class="button is-danger" :class="{'is-loading': isSubmitting}" @click="submit" :disabled="veeErrors.any() || !accept">Annullér Projektet</button>
                </footer>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import ProjectService from '@/taskflex/projects/services/ProjectService';

    export default {
        data() {
            return {
                showModal: false,
                isSubmitting: false,
                message: null,
                accept: false,
            };
        },

        props: {
            project: {
                type: Object,
                required: true,
            },
        },

        methods: {
            async submit() {
                if (!await this.$validator.validateAll()) {
                    return;
                }

                const options = {
                    message: this.message,
                };

                this.isSubmitting = true;

                ProjectService.cancelProject(this.project.id, options, ({ data }) => {
                    this.isSubmitting = false;
                    this.showModal = false;

                    this.$emit('cancelled', data);
                });
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/conversations/components/Projects/ProjectActions/CancelProjectAction.vue